import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Device, DeviceCart, DeviceFeature, Role } from '@kion/data-models';

@Component({
  selector: 'kion-feature-list',
  templateUrl: './feature-list.component.html',
  styleUrls: ['./feature-list.component.scss']
})
export class FeatureListComponent {

  @Input() device: Device;
  @Input() features: DeviceFeature[];
  @Input() cart: DeviceCart;
  @Input() roles: Role[];

  // tslint:disable-next-line:no-output-rename
  @Output('addToCart') addToCartClickedEmitter: EventEmitter<{ean: string; salesRule: string}> = new EventEmitter<{ean: string, salesRule: string}>();

  addToCartClicked(event: {ean: string; salesRule: string}) {
    this.addToCartClickedEmitter.emit(event);
  }
}
